import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { SearchBox, Form } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'
import * as API from 'modules/app/API'

class SearchBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				default: '',
				preset: 'Admin',
				disabled: ''
			}
		};
	}

	usersLoader = () => {
		return {
            url: API.Search.url('/suggest'),
            params: {
                type: 'user'
            }
		}
	}

	onChange = (form, callback) => {
		this.setState({ form }, callback);
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="SearchBox">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={12}>
							<Label htmlFor="searchText">Default</Label>
							<SearchBox
								name="default"
								placeholder="Enter username..."
								loader={this.usersLoader} />
						</Col>
					</Row>
					<Row>
						<Col md={12}>
							<Label htmlFor="searchText">Preset</Label>
							<SearchBox
								name="preset"
								placeholder="Enter username..."
								loader={this.usersLoader} />
						</Col>
					</Row>
					<Row>
						<Col md={12}>
							<Label htmlFor="disabled">Disabled</Label>
							<SearchBox
								name="searchText"
								placeholder="Enter username..."
								loader={this.usersLoader}
								disabled/>
						</Col>
					</Row>					
					<hr />
					<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
				</Form>
			</Box>
		)
	}
}

export default SearchBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/DropDowns/SearchBoxDemo.js